import { DefaultApi } from './api'

export const logout = () =>
  DefaultApi.request('/auth/logout', {
    method: 'GET',
    withCredentials: true,
  })
